export { default as CommentSwitcher } from './CommentSwitcher.vue'
export { default as EmojiPicker } from './EmojiPicker.vue'
export { default as EventsPicker } from './EventsPicker.vue'
export { default as FileUpload } from './FileUpload.vue'
export { default as FormatToolbar } from './FormatToolbar.vue'
export { default as GifPicker } from './GifPicker.vue'
export { default as HashPicker } from './HashPicker.vue'
export { default as LinkEmbed } from './LinkEmbed.vue'
export { default as VideoUploadModal } from './VideoUploadModal.vue'

// Re-export validation types
export type {
  ContentValidation,
  EditorValidation,
  EmojiValidation,
  FileUploadValidation,
  ImageUploadValidation,
  LinkValidation,
  VideoUploadValidation,
} from '../types/validation.types'

// Tool types
export interface EditorToolConfig {
  emojiPicker?: boolean
  imageUpload?: boolean
  videoUpload?: boolean
  fileUpload?: boolean
  linkEmbed?: boolean
  // Future tools
  gif?: boolean
  mention?: boolean
}
